import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Helmet } from "react-helmet";

class Public extends React.PureComponent {
  render() {
    const { title, container } = this.props;

    return (
      <div>
        <GoogleReCaptchaProvider reCaptchaKey="6LeB7vcZAAAAABNLj0gRMy-LRLEf6XvQZGzajCwc">
          <Helmet>
            <title>{title}</title>
          </Helmet>
          {container}
        </GoogleReCaptchaProvider>
      </div>
    );
  }
}

export default Public;
